export const styles = {
  avatar: { cursor: "pointer" }
};
